export default __webpack_public_path__ + "static/tradeFare-2fcda4e58a53168f201501e2d887b9e4.png";